import * as React from 'react';

import * as styles from './CalculateResultModalContent.css';

interface ICalculateResultModalContentProps {
  children: React.ReactNode;
}

export const CalculateResultModalContent: React.FC<ICalculateResultModalContentProps> = ({ children }) => (
  <div className={styles['container']}>{children}</div>
);
